module.exports = __webpack_public_path__ + "04a780a5.svg";